import { render, staticRenderFns } from "./InterventionsCount.vue?vue&type=template&id=52d14c8e"
import script from "./InterventionsCount.vue?vue&type=script&lang=ts"
export * from "./InterventionsCount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports